/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelFuelCard.ts                      *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/asset/fuel-card";

export class AutogenModelFuelCard<RowType extends ModelRow> extends Endpoint<RowType, RowFuelCardFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowFuelCard extends ModelRow<RowFuelCardFields> {
	constructor(values?: Partial<RowFuelCardFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowFuelCardFields {
	account_id: string;
	assignee_type: string;
	card_status: string;
	charge_code: string;
	company_id: string;
	deposit_payee_id: string;
	driver_id: string;
	fuel_expense_id: string;
	fuel_interface_id: string;
	id: string;
	is_card_payroll: string;
	is_crossroads: string;
	payee_id: string;
	sub_account: string;
	time_zone: string;
	tractor_id: string;
	trailer_id: string;
	type_deposit: string;
}

